import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import store from "@/store";
import NProgress from "nprogress";

Vue.use(VueRouter);

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  mode: "history",
  linkActiveClass: "active",
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  let user = localStorage.getItem("user");
  let logged_in_user = null;

  try {
    logged_in_user = JSON.parse(user); // may throw error if user edits the user object in localstorage
    store.dispatch("user/set", logged_in_user);
  } catch (e) { }

  if (
    to.matched.some(record => record.meta.requires_auth && record.meta.admin)
  ) {
    if (
      logged_in_user &&
      logged_in_user.auth != null &&
      logged_in_user.account_type == "admin"
    ) {
      next();
      return;
    }
    next("/login");
  } else if (to.matched.some(record => record.meta.requires_auth)) {
    if (logged_in_user && logged_in_user.auth != null) {
      next();
      return;
    }
    next("/login");
  } else {
    next();
  }
});

router.beforeEach((routeTo, routeFrom, next) => {
  NProgress.start();
  next();
});

router.afterEach((to, from, next) => {
  NProgress.done();

  let title = "Power Up";
  if (to && to.name == "Board") {
    // let name = store.getters["monday/get_board_name"](to.params.id, to);
    store.dispatch("monday/get_board_name", { board_id: to.params.id, to: to }).then(name => {
      to.meta.title = name;
      document.title = to.meta.title || title;
    })
  } else {
    // show static page titles
    document.title = to.meta && to.meta.title ? to.meta.title : title;
  }
});

export default router;
